var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useSyncExternalStore } from 'react';
var familyMemberPlaceholder = {
    name: null,
    birthDate: null,
    gender: null,
    height: null,
    activity: null,
    commonAllergies: null,
    ingredients: null,
    growthSpeed: null,
    allergies: null,
    dietType: null,
};
var familyMember = __assign({}, familyMemberPlaceholder);
/**
 * Il draft del membro è uno solo per tutta l'app: i consumer vengono notificati
 * ad ogni scrittura. Senza le notifiche ogni istanza dell'hook conserverebbe la
 * copia letta al mount, quindi un resetProfile() fatto da una pagina non
 * arriverebbe ai form già montati (es. la sidebar "Aggiungi membro", che resta
 * montata anche quando è chiusa) e questi resterebbero pre-compilati con i dati
 * dell'ultimo profilo visualizzato.
 */
var listeners = new Set();
var subscribe = function (listener) {
    listeners.add(listener);
    return function () {
        listeners.delete(listener);
    };
};
var getSnapshot = function () { return familyMember; };
var publish = function (newProfile) {
    familyMember = newProfile;
    listeners.forEach(function (listener) { return listener(); });
};
export var useFamilyMemberComposer = function () {
    var profile = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
    var setProfile = useCallback(function (property, callback) {
        publish(__assign(__assign({}, familyMember), property));
        // Esegui callback solo se fornito, ma non immediatamente
        if (callback) {
            setTimeout(function () { return callback(familyMember); }, 0);
        }
    }, []);
    var resetProfile = useCallback(function () {
        publish(__assign({}, familyMemberPlaceholder));
    }, []);
    return {
        profile: profile,
        setProfile: setProfile,
        resetProfile: resetProfile,
    };
};
